<div class="container-fluid text-white pb-5" style="min-height: 100vh; display: flex; flex-direction: column;">

    <div class="row">
        <div class="col-12 text-center py-3 position-relative">
            <button class="btn-back-to-home" (click)="router.navigate(['/contents/pages/landing-page'])"> <i
                    class="fa fa-chevron-left" aria-hidden="true"></i> </button>
            <h3> {{ title }} </h3>
        </div>
    </div>

    <ng-container *ngIf="gameList && gameList.ProviderDisabled === true; else showGameDiv">
        <div class="d-flex justify-content-center align-items-center text-white" style="flex-grow: 1; height: 100% !important">
            <div class="text-center">
                <div class="p-3" style="border: 1px solid #fff; border-radius: 10px;">
                    <span class="i18n">{{ 'contents.provider.disable' | translate }}</span>
                </div>
            </div>
        </div>
    </ng-container>

    <ng-template #showGameDiv>
        <div class="row">
            <div class="col-12">
                <div class="game-list">
                    <ng-container *ngIf="gameList && gameList.Records.length > 0; else noData">
                        <div class="game-list-hot-box">
                            <ng-container *ngFor="let game of gameList.Records">
                                <div class="game-item class-4 {{ game.IsMaintenance ? 'maintenance-overlay' : ''}}">
                                    <div *ngIf="game.IsMaintenance" class="maintenance">
                                        <div> {{'contents.game.maintenance' | translate}} </div>
                                    </div>
                                    <div class="game-item-top" (click)="enterGame(game);">
                                        <div class="game-item-img">
                                            <img [src]="getImageSource(game)" />
                                        </div>
                                    </div>
                                    <em class="hot-name i18n">
                                        {{ getSupplierDisplayName(game) }}</em>

                                </div>
                            </ng-container>
                        </div>
                    </ng-container>

                    <ng-template #noData>
                        <p>{{ 'app_spinner_text' | translate}}</p>
                    </ng-template>
                </div>
            </div>
        </div>
    </ng-template>
</div>
<!-- </div> -->